import { Section } from "./ui";
import { Link } from "react-router-dom";
import { PHONE_E164, PHONE_DISPLAY, ADDRESS_LOCALITY, ADDRESS_REGION } from "../lib/site";

export function Footer() {
  return (
    <footer className="bg-brand-dark border-t border-white/10 pt-12 md:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16">
          <div className="col-span-2 flex flex-col items-center text-center lg:items-start lg:text-left">
            <Link to="/" className="mb-4 md:mb-6 block inline-block">
              <img src="https://p2amarketing.com.br/wp-content/uploads/2026/03/Logo-branca-Sem-fundo.png" alt="P2A" className="h-10 md:h-12 w-auto" />
            </Link>
            <p className="text-brand-light/70 max-w-[280px] lg:max-w-sm text-sm md:text-base">
              Transformamos sua estratégia em resultados concretos. Marketing, Branding e Tecnologia para negócios que querem liderar o mercado.
            </p>
            {/* NAP (Nome, Endereço, Telefone) em texto — atendimento nacional,
                por isso só cidade/estado, sem endereço completo. */}
            <p className="text-brand-light/50 text-sm md:text-base mt-4">
              P2A Marketing & Branding — {ADDRESS_LOCALITY}/{ADDRESS_REGION}
              {" — "}
              <a href={`tel:${PHONE_E164}`} className="hover:text-brand-accent transition-colors">
                {PHONE_DISPLAY}
              </a>
            </p>
          </div>
          
          <div className="col-span-1 text-center lg:text-left">
            <h4 className="text-white font-bold mb-4 md:mb-6 text-sm md:text-base">Links Rápidos</h4>
            <ul className="space-y-3 md:space-y-4">
              <li><Link to="/" className="text-brand-light/70 hover:text-brand-accent transition-colors text-sm md:text-base">Início</Link></li>
              <li><Link to="/servicos" className="text-brand-light/70 hover:text-brand-accent transition-colors text-sm md:text-base">Serviços</Link></li>
              <li><Link to="/sobre" className="text-brand-light/70 hover:text-brand-accent transition-colors text-sm md:text-base">Sobre</Link></li>
              <li><Link to="/#blog" className="text-brand-light/70 hover:text-brand-accent transition-colors text-sm md:text-base">Blog</Link></li>
            </ul>
          </div>
          
          <div className="col-span-1 text-center lg:text-left">
            <h4 className="text-white font-bold mb-4 md:mb-6 text-sm md:text-base">Legal</h4>
            <ul className="space-y-3 md:space-y-4">
              <li><a href="#" className="text-brand-light/70 hover:text-brand-accent transition-colors text-sm md:text-base">Política de Privacidade</a></li>
              <li><a href="#" className="text-brand-light/70 hover:text-brand-accent transition-colors text-sm md:text-base">Termos de Uso</a></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-center gap-4 text-sm text-brand-light/50">
          <p>&copy; 2025 P2A Marketing. Todos os direitos reservados.</p>
          <p>Desenvolvido com tecnologia de ponta.</p>
        </div>
      </div>
    </footer>
  );
}
